<template lang="html">
  <div class="full-page">
    <i-header :title="$route.query.title" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body >
      <i-group-cell title="自然人" style="background:#fff;margin-bottom: 10px;">
        <i-cell
          @click="$_cellJump('/guide/specific/natural/one', '普通投资者自然人')"
          style="font-size: 14px;">普通投资者
        </i-cell>
        <i-cell
          @click="$_cellJump('/guide/specific/natural/two', '专业投资者自然人')"
          style="font-size: 14px;">专业投资者
        </i-cell>
        <i-cell
          @click="$_cellJump('/guide/specific/natural/three', '员工跟投')"
          style="font-size: 14px;">员工跟投
        </i-cell>
      </i-group-cell>
      <i-group-cell title="机构" style="background:#fff;margin-bottom: 10px;">
        <i-cell
          @click="$_cellJump('/guide/specific/corporate/one', '普通投资者机构')"
          style="font-size: 14px;">普通投资者
        </i-cell>
        <i-cell
          @click="$_cellJump('/guide/specific/corporate/two', '专业投资者机构')"
          style="font-size: 14px;">专业投资者（法人及其他组织）
        </i-cell>
        <i-cell
          @click="$_cellJump('/guide/specific/corporate/three', '金融机构')"
          style="font-size: 14px;">金融机构
        </i-cell>
        <i-cell
          @click="$_cellJump('/guide/specific/corporate/four', '本机构')"
          style="font-size: 14px;">本机构
        </i-cell>
      </i-group-cell>
    </i-body>
  </div>
</template>

<script>
export default {
  methods: {
    $_cellJump(url, title) {
      this.$router.push({
        path: url,
        query: { title },
      });
    },
  },
};
</script>

<style lang="css">
</style>
